import React from "react";
import { Avatar, CircularProgress, IconButton, Tooltip } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";

const AVATAR_BORDER_STYLE = {
  bgcolor: "common.white",
  color: "text.secondary",
  border: "1px solid",
  borderColor: "table.border",
  width: "40px",
  height: "40px",
} as const;

interface OrganizationAvatarMenuProps {
  orgName: string;
  orgLogoUrl?: string;
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  menuOpen?: boolean;
}

export default function OrganizationAvatarMenu({
  orgName,
  orgLogoUrl,
  isLoading = false,
  onClick,
  menuOpen = false,
}: OrganizationAvatarMenuProps) {
  return (
    <Tooltip title="Organization Menu" enterDelay={500}>
      <IconButton
        onClick={onClick}
        aria-label={`${orgName} Menu`}
        aria-controls={
          menuOpen ? "unity-courtesy-header-org-unit-menu" : undefined
        }
        aria-haspopup="true"
        aria-expanded={menuOpen}
        {...telemetryProps({ name: "header_org_avatar", section: "unified_header", label: "Organization Menu" })}
      >
        {isLoading ? (
          <Avatar component={"span"} sx={AVATAR_BORDER_STYLE}>
            <CircularProgress size={24} sx={{ color: "text.secondary" }} />
          </Avatar>
        ) : orgLogoUrl ? (
          <Avatar
            component={"span"}
            src={orgLogoUrl}
            alt={orgName}
            sx={{
              ...AVATAR_BORDER_STYLE,
              "& img": {
                objectFit: "contain",
                objectPosition: "center",
              },
            }}
          />
        ) : (
          <Avatar
            component={"span"}
            sx={[
              () => ({
                width: "40px",
                height: "40px",
                border: "1px solid",
              }),
              (theme) =>
                theme.applyStyles("dark", {
                  color: theme.palette.text.primary,
                  bgcolor: theme.palette.grey[800],
                  borderColor: theme.palette.grey[600],
                }),
              (theme) =>
                theme.applyStyles("light", {
                  color: theme.palette.text.secondary,
                  bgcolor: theme.palette.common.white,
                  borderColor: theme.palette.table.border,
                }),
            ]}
          >
            <BusinessIcon sx={{ fontSize: 24, color: "text.secondary" }} />
          </Avatar>
        )}
      </IconButton>
    </Tooltip>
  );
}
